import React, { useState, lazy, Suspense } from "react";
import Hero from "../components/Hero";
import Hero3 from "../components/Hero3";
import Counter from "../components/Counter";
import PopularCourses from "../components/PopularCourses";
import SEO from "../components/SEO";

// Lazy components
const DasaraDhamakaSection = lazy(() => import("../components/DasaraDhamakaSection"));
const Modal = lazy(() => import("../components/Modal"));
const Modal2 = lazy(() => import("../components/Modal2"));
const VideoModal = lazy(() => import("../components/VideoModal"));
const ELearning = lazy(() => import("../components/ELearning"));
const Projects = lazy(() => import("../components/Projects"));
const Whymd = lazy(() => import("../components/Whymd"));
const Cert = lazy(() => import("../components/Cert"));
const Coursepage = lazy(() => import("../components/Coursepage"));
const CourseHighlights = lazy(() => import("../components/CourseHighlights"));
const IndustryTrainers = lazy(() => import("../components/IndustryTrainers"));
const IndustryTrainers2 = lazy(() => import("../components/IndustryTrainers2"));
const ReviewsSection = lazy(() => import("../components/ReviewsSection"));
const DemoSessionCard = lazy(() => import("../components/DemoSessionCard"));
const Faq = lazy(() => import("../components/Faq"));
const Recognisation = lazy(() => import("../components/RecognisationSection"));
const JoinMicroDegree = lazy(() => import("../components/JoinMicroDegree"));
const NewsMedia = lazy(() => import("../components/News&Media"));
const HomeForm2 = lazy(() => import("../components/HomeForm2"));
const Demovideo = lazy(() => import("../components/Demovideo"));
const Offer = lazy(() => import("../components/Offer"));
const Linkedin = lazy(() => import("../components/Linkedin"));
const Ebook = lazy(() => import("../components/Ebook"));
const Techharate = lazy(() => import("../components/Techharate"));
const Th = lazy(() => import("../components/Th"));
// extra lazy imports (already defined in your code, but unused)
// const Learners = lazy(() => import("../components/Learners"));
// const Placements = lazy(() => import("../components/Placements"));
// const EmpoweringColleges = lazy(() => import("../components/EmpoweringColleges"));
// const Certificates = lazy(() => import("../components/Certificates"));
// const TrainersFeedback = lazy(() => import("../components/TrainersFeedback"));
// const Team = lazy(() => import("../components/Team"));
// const Scholarship = lazy(() => import("../components/Scholarship"));
// const YTFullCourse = lazy(() => import("../components/YTFullCourse"));
// const Devopsforkannadigas = lazy(() => import("../components/Devopsforkannadigas"));
// const Pythonforkannadigas = lazy(() => import("../components/Pythonforkannadigas"));
// const HomeForm1 = lazy(() => import("../components/HomeForm1"));
// const Video = lazy(() => import("../components/Video"));
// const Toptools = lazy(() => import("../components/Toptools"));

function Home({ handleAlert }) {
  const [videoModal, setVideoModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [videoOutput, setVideoOutput] = useState();
  const [learnerVideo, setLearnerVideo] = useState("");
  const [learnerModal, setLearnerModal] = useState(false);
  const [viewModal2, setViewModal2] = useState(false);

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'EducationalOrganization',
    name: "MicroDegree",
    url: 'https://www.microdegree.work/',
    logo: 'https://www.microdegree.work/static/media/MicroDegree%20Pink.5777a8ffd9ff3026b011.png',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '0804-710-9999',
      contactType: 'customer service',
      areaServed: 'IN',
      availableLanguage: ['en', 'Kannada'],
    },
    sameAs: [
      'https://www.facebook.com/microdegree',
      'https://x.com/micro_degree',
      'https://www.instagram.com/microdegree.work/',
      'https://www.youtube.com/microdegree',
      'https://www.linkedin.com/company/microdegree/',
      'https://www.microdegree.work/',
    ],
  };

  return (
    <>
      <SEO
      title="MicroDegree – Kannada's No.1 Tech Skilling Platform"
      description="Upskill or transition to top tech roles with expert-led courses in Kannada. AWS, DevOps, GenAI & more. Join MicroDegree — Making Kannadigas Global Tech Talent."
      canonical="https://www.microdegree.work/"
      schema={schema}
    />
    
    <div className="relative overflow-x-hidden">
      <div className="main_container relative">
        {/* Modals */}
        {viewModal && (
          <Suspense fallback={<div className="p-4 animate-pulse">Loading...</div>}>
            <Modal handleAlert={handleAlert} viewModal={viewModal} setViewModal={setViewModal} />
          </Suspense>
        )}
        {viewModal2 && (
          <Suspense fallback={<div className="p-4 animate-pulse">Loading...</div>}>
            <Modal2 handleAlert={handleAlert} viewModal2={viewModal2} setViewModal2={setViewModal2} />
          </Suspense>
        )}
        {videoModal && (
          <Suspense fallback={<div className="p-4 animate-pulse">Loading video...</div>}>
            <VideoModal
              vidLink={videoOutput?.link}
              vidTitle={videoOutput?.title}
              setvideoModal={setVideoModal}
              videoModal={videoModal}
            />
          </Suspense>
        )}
        {learnerModal && (
          <Suspense fallback={<div className="p-4 animate-pulse">Loading video...</div>}>
            <VideoModal setvideoModal={setLearnerModal} videoModal={learnerModal} vidLink={learnerVideo} />
          </Suspense>
        )}

        {/* Hero Section (eager load for LCP) */}
        <section id="hero">
          <Hero3
            viewModal={viewModal}
            setViewModal={setViewModal}
            viewModal2={viewModal2}
            setViewModal2={setViewModal2}
            videoModal={videoModal}
            setvideoModal={setVideoModal}
            videoOutput={videoOutput}
            setVideoOutput={setVideoOutput}
          />
        </section>

        {/* Keep Order – Wrap Lazy */}
        <Suspense fallback={<div className="p-6 text-center animate-pulse min-h-screen">Loading content...</div>}>
          {/* <DasaraDhamakaSection /> */}
          {/* <ELearning /> */}
          <Projects setViewModal={setViewModal} setViewModal2={setViewModal2} />
          {/* <Offer /> */}
          <Whymd />
          <Counter />
          <Cert />
          <Coursepage />
          <CourseHighlights />
          <DemoSessionCard />
          {/* <IndustryTrainers /> */}
          <IndustryTrainers2 />
          <Demovideo />
          {/* <PopularCourses /> */}
          <div className="my-10"></div>
          {/* <YTFullCourse /> */}
          {/* <Placements /> */}
          <ReviewsSection />
          {/* <Linkedin /> */}
          <Ebook />
          <Faq />
          <Recognisation />
          <JoinMicroDegree />
          {/* <Scholarship /> */}
          {/* <HomeForm1 /> */}
          <NewsMedia />
          {/* <Team /> */}
          <Th />
          <HomeForm2 />
          {/* <Video /> */}
        </Suspense>
      </div>
    </div>
  </>
  );
}

export default Home;